import React, { useEffect } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

const AdminToolsLayout = ({ auth, children }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || (auth.platform_role !== 'super_admin' && auth.platform_role !== 'admin')) {
      history.push('/');
    }
  }, [auth, history]);

  if (!auth || (auth.platform_role !== 'super_admin' && auth.platform_role !== 'admin')) {
    return null;
  }

  const navLinkStyle = {
    display: 'block',
    padding: '0.75rem 1rem',
    color: '#64748b',
    textDecoration: 'none',
    borderRadius: '8px',
    marginBottom: '0.25rem',
    transition: 'all 0.2s',
    fontSize: '0.9rem',
    fontWeight: '500'
  };

  const navLinkActiveStyle = {
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    color: 'white'
  };

  const navItems = [
    { to: '/admin/tools/access-codes', label: 'Access Codes', icon: 'M15 7a2 2 0 0 1 2 2m4 0a6 6 0 0 1-7.743 5.743L11 17H9v2H7v2H4a1 1 0 0 1-1-1v-2.586a1 1 0 0 1 .293-.707l5.964-5.964A6 6 0 1 1 21 9z' },
    { to: '/admin/tools/spend-report', label: 'Spend Report', icon: 'M12 2v20m0-20l-4 4m4-4l4 4M12 22l-4-4m4 4l4-4' },
    { to: '/admin/tools/finances', label: 'Finances', icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { to: '/admin/tools/model-catalog', label: 'Model Catalog', icon: 'M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6zm2 0v12h12V6H6z' },
    { to: '/admin/tools/settings', label: 'Settings', icon: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 0v7m0-17v3m-5.196 2.904l-2.122-2.122m14.636 0l-2.122 2.122M4.93 17.07l2.122-2.122m9.9 0l2.12 2.122' },
    { to: '/admin/tools/prompts', label: 'Prompts', icon: 'M8 9h8m-8 4h6m-9 7h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z' },
    { to: '/admin/platform/articles', label: 'Articles', icon: 'M19 20H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1m2 13a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2z' },
    { to: '/admin/tools/error-log', label: 'Error Log', icon: 'M12 8v4m0 4v.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { to: '/admin/tools/allowlist', label: 'Allowlist', icon: 'M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z' },
    { to: '/admin/tools/blocklist', label: 'Blocklist', icon: 'M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636' },
    { to: '/admin/tools/pending-domains', label: 'Pending Domains', icon: 'M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z' },
    { to: '/admin/tools/analytics', label: 'Analytics', icon: 'M9 19v-6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm0 0V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10m-6 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m0 0V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z' },
    { to: '/admin/tools/url-log', label: 'URL Log', icon: 'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
    { to: '/admin/tools/delete-review', label: 'Delete Review', icon: 'M19 7l-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16' }
  ];

  return (
    <>
      <Helmet>
        <title>Article to Media Admin | Spawnry</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '100px 0 3rem',
        marginBottom: '2rem'
      }}>
        <Container>
          <h1 style={{
            color: 'white',
            fontWeight: '700',
            fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
            marginBottom: '0.5rem'
          }}>
            Article to Media Admin
          </h1>
          <p style={{ color: 'rgba(255, 255, 255, 0.7)', margin: 0 }}>
            Manage access codes, settings, and monitor usage
          </p>
        </Container>
      </div>

      <Container style={{ paddingBottom: '3rem' }}>
        <Row>
          <Col md={3} className="mb-4">
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '1rem',
              boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              position: 'sticky',
              top: '100px'
            }}>
              <Nav className="flex-column">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    style={navLinkStyle}
                    activeStyle={navLinkActiveStyle}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginRight: '0.6rem', verticalAlign: '-2px' }}
                    >
                      <path d={item.icon} />
                    </svg>
                    {item.label}
                  </NavLink>
                ))}
              </Nav>
            </div>
          </Col>

          <Col md={9}>
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '1.5rem',
              boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              minHeight: '400px'
            }}>
              {children}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminToolsLayout);
